<template>
  <div class="echo">
    <div class="head flex_r">
      <div class="flex1 f32 flex_r fw600">
        <svgIcon class="f44" name="echo" />
        <span class="line44 marginl12">回音檐廊</span>
      </div>
      <router-link to="comment" class="sub flex0">发布帖子</router-link>
      <div @keyup.enter='resetEcho' class="search flex0 flex_r">
        <input v-model="kw" type="text" placeholder="搜索帖子标题或作者" class="input" />
        <SvgIcon @click.native="resetEcho"  name="search" />
      </div>
    </div>
    <echoGroup :echoArr='echoList' />
  </div>
</template>
<script>
export default {
  name: "echo",
  data() {
    return {
      echoList:[],
      page_count: 1,
      kw: '',
      echoPage: 1,
    };
  },
  mounted(){
    this.getEcho();
  },
  methods: {
    async getEcho() {
      let { data } = await this.$http(this.$api.tzList, {
        params: {
          uid: 0,
          page: this.echoPage,
          kw: this.kw,
        },
      });
      this.echoList = data.list;
      this.page_count = data.page_count;
      if (this.page_count < 10) {
        this.pageTest = [];
        this.pageTest2 = [];
      }
    },
    resetEcho(){
      this.echoPage = 1;
      this.getEcho();
    }
  },
};
</script>
<style lang="less" scoped>
.echo {
  width: 1200px;
  margin: auto;
  .sub {
    height: 36px;
    padding: 0 20px;
    font-size: 16px;
    color: white;
    line-height: 36px;
    box-sizing: border-box;
    background: #ad2729;
    border-radius: 18px;
  }
  .search {
    width: 250px;
    height: 40px;
    margin-left: 12px;
    padding: 9px 12px;
    box-sizing: border-box;
    background: #fafafa;
    border-radius: 20px;
    border: 1px solid #e6e6e6;
    input {
      width: 100%;
      height: 100%;
      font-size: 16px;
      background: transparent;
      &::placeholder {
        color: #958f8f;
      }
    }
    .svg-icon--search {
      font-size: 24px;
      color: #ad2729;
    }
  }
}
</style>